import request from '@/utils/request'

/**
 * 获取会员权益信息
 * @returns 
 */
export function getVipRights() {
    return request.post("/member/vip/rights");
}

/**
 * 获取用户积分明细
 * @param {*} params {pageNum:1, pageSize:10}
 * @returns 
 */
export function getCustScoreRecord(params) {
    return request.post("/member/score/custScoreRecord", params);
}

/**
 * 
 * @returns 获取签到信息
 */
export function getSignSummary() {
    return request.post("/member/score/sign/getSignSummary");
}

/**
 * 
 * @returns 开始签到
 */
export function addSignRecord() {
    return request.post("/member/score/sign/addSignRecord")
}

/**
 * 获取获赠记录
 * @param {*} params {pageNum:1, pageSize:10}
 * @returns 
 */
export function getSubscribeSendScore(params) {
    return request.post("/member/score/getSubscribeSendScore", params)
}

/**
 * 
 * @returns 获取生日礼遇 等级及积分
 */
export function getBirthdayScoreConfig() {
    return request.post("/member/score/getBirthdayScoreConfig")
}

/**
 * 
 * @returns 在生日当天，获取相应的积分
 */
export function birthdaySendScore() {
    return request.post("/member/score/add/birthdaySendScore")
}

/**
 * 获取持有金额会员等级区间
 * @returns 
 */
export function getVipLevel() {
    return request.post("/member/score/manage/vipLevel")
}

/**
 * 获取会员积分的系数
 * @returns 
 */
export function getScoreCoefficient() {
    return request.post("/member/score/manage/scoreCoefficient")
}

export function getScoreRules() {
    return request.post("/member/score/rules")
}